import { render, staticRenderFns } from "./GtsSlider.vue?vue&type=template&id=c023b458&scoped=true"
import script from "./GtsSlider.vue?vue&type=script&lang=js"
export * from "./GtsSlider.vue?vue&type=script&lang=js"
import style0 from "./GtsSlider.vue?vue&type=style&index=0&id=c023b458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c023b458",
  null
  
)

export default component.exports